import React, { useContext, useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { TitleText, LabelText } from '../../../ui/Text';
import { ToggleButton } from '../../../ui/ToggleButton';
import { CircleIcon } from '../../../assets/svg/CircleIcon';
import { ScorecardIcon } from '../../../assets/svg/ScorecardIcon';
import { Button } from '../../../ui/Button';
import { Formik, Field } from 'formik';
import { DropDown } from '../../../ui/DropDown';
import LineGraph from '../../../components/LineGraph/LineGraph';
import { IndicatorIcon } from '../../../assets/svg/IndicatorIcon';
import Measures from './Measures';
import { get } from '../../../utils/get';
import DateRangePicker3 from '../../../ui/DateRangePicker3';
import { jsPDF } from 'jspdf';
import { sortPerspectives } from '../../../utils/sortPerspectivesScorecard';
import { GetHook } from '../../../api/api';
import { SCORECARD_KPI_TARGET } from '../../../api/urls';
import axios from '../../../utils/axios';

interface Props {
  title?: string;
  data: any[];
  objectives?: any;
  perspectives?: any;
  name?: string;
  setDateFilter?: any;
}
const getColor = score => {
  switch (true) {
    case score >= 1 && score < 2:
      return '#D51067';
    case score >= 2 && score <= 3:
      return '#EDBC0C';
    case score > 3:
      return '#4BD041';
    case score >= 5:
      return 'url(#grad2)';
    default:
      return '#D51067';
  }
};
const DataView = ({
  title,
  data,
  name,
  setDateFilter,
  objectives = [],
  perspectives = []
}: Props) => {
  const dataViewRef = useRef<any>();
  const [kpiTargets, setKpiTargets] = useState<any>([]);

  useEffect(() => {
    let zoom = ((window.outerWidth - 10) / window.innerWidth) * 100;
    if (zoom > 100) {
      //@ts-ignore
      document.body.style.zoom = '85%';
    }
    return () => {
      //@ts-ignore
      document.body.style.zoom = '100%';
    };
  }, []);

  function printDiv() {
    const html = dataViewRef.current;
    const width = html.clientWidth;
    const height = html.clientHeight;

    const doc = new jsPDF('p', 'pt', [795.26, 995]);
    //get svg elements and hide them
    const svgElements: any = html.querySelectorAll('svg');
    const button = html.querySelector('button');
    button.style.display = 'none';
    svgElements.forEach(svg => (svg.style.display = 'none'));

    doc.html(html, {
      html2canvas: {
        scale: 795.26 / width,
        scrollY: 0,
        scrollX: 0
      },
      callback: function () {
        doc.setFontSize(9);
        doc.save('scorecard Data.pdf');
        svgElements.forEach(svg => (svg.style.display = ''));
        button.style.display = '';
      }
    });
  }

  useEffect(() => {
    let kpiId = data.map(kpiId => {
      return {
        value: get(kpiId, 'id', '')
      };
    });
    const promises: any = data?.map(item => {
      return axios
        .get(`${SCORECARD_KPI_TARGET}?scorecard_kpi_id=${get(item, 'id')}`)
        .then((res: any) => {
          const kpi = {
            id: item.id,
            data: res?.data?.returned_resultset
          };

          return kpi;
        });
    });
    Promise.all(promises).then(function (promiseValues) {
      setKpiTargets(promiseValues);
    });
  }, [data]);

  const fetchTargets = id => {
    const targets = kpiTargets?.find(item => item.id === id)?.data;
    return targets?.map(kpiTarget => {
      return {
        value: get(kpiTarget, 'id', ''),
        label: get(kpiTarget, 'label', ''),
        score: get(kpiTarget, 'score', ''),
        target: get(kpiTarget, 'target', ''),
        actual_value: get(kpiTarget, 'actual_value', '')
      };
    });
  };
  console.log(objectives);

  return (
    <DataViewContainer id='container' ref={dataViewRef}>
      <DataSection>
        <SectionHeader>
          <Formik initialValues={{}} onSubmit={() => console.log('object')}>
            {({ values }) => {
              setDateFilter && setDateFilter(get(values, 'date_range'));
              return (
                <>
                  <TitleText>
                    <span
                      style={{ fontSize: 12, color: '#214160', opacity: 0.4 }}
                    >
                      {title} name
                    </span>
                    <span style={{ fontSize: 16 }}>{name}</span>
                  </TitleText>
                  <DateRangeContainer>
                    <Field
                      name='date_range'
                      label='Time Period'
                      component={DateRangePicker3}
                    />
                  </DateRangeContainer>
                  <Button text='print' onClick={() => printDiv()} />
                </>
              );
            }}
          </Formik>
        </SectionHeader>
        {/* <LineGraph /> */}
        <Data>
          {objectives?.length && perspectives?.length
            ? sortPerspectives(perspectives).map(perspective => (
                <>
                  <TitleText
                    style={{
                      fontSize: 18,
                      color: '#214160',
                      marginTop: '2em'
                    }}
                  >
                    {get(perspective, 'perspective_name')}
                  </TitleText>
                  {objectives
                    .filter(
                      objective =>
                        get(objective, 'perspective_id') ===
                        get(perspective, 'perspective_id')
                    )
                    .map(objective => {
                      return (
                        <>
                          <TitleText
                            style={{
                              fontSize: 16,
                              color: '#214160',
                              opacity: 0.7,
                              marginTop: '2em'
                            }}
                          >
                            {get(objective, 'objective_name')}
                          </TitleText>
                          {data &&
                            data
                              .filter(
                                kpi =>
                                  kpi.objective_id ===
                                  get(objective, 'objective_id')
                              )
                              .map(item => {
                                console.log(item);

                                return (
                                  <MeasuresContainer key={item.objective_id}>
                                    <span>
                                      <IndicatorIcon
                                        color={getColor(item.score)}
                                      />
                                      <TitleText>
                                        {get(item, 'kpi_name')}
                                      </TitleText>
                                    </span>
                                    <Measures
                                      data={fetchTargets(item.id) || []}
                                      getColor={getColor}
                                    />
                                  </MeasuresContainer>
                                );
                              })}
                        </>
                      );
                    })}
                </>
              ))
            : objectives?.length && !perspectives.length
            ? objectives.map(objective => (
                <>
                  <TitleText
                    style={{
                      fontSize: 16,
                      color: '#214160',
                      opacity: 0.7,
                      marginTop: '1em'
                    }}
                  >
                    {get(objective, 'objective_name')}
                  </TitleText>
                  {data &&
                    data.map(item => {
                      return (
                        <MeasuresContainer key={item.id}>
                          <span>
                            <IndicatorIcon color={getColor(item.score)} />
                            <TitleText>{get(item, 'kpi_name')}</TitleText>
                          </span>
                          <Measures
                            data={fetchTargets(item.id) || []}
                            getColor={getColor}
                          />
                        </MeasuresContainer>
                      );
                    })}
                </>
              ))
            : data &&
              data.map(item => (
                <MeasuresContainer key={item.id}>
                  <span>
                    <IndicatorIcon color={getColor(item.score)} />
                    <TitleText>{get(item, 'kpi_name')}</TitleText>
                  </span>
                  <Measures
                    data={fetchTargets(item.id) || []}
                    getColor={getColor}
                  />
                </MeasuresContainer>
              ))}
        </Data>
      </DataSection>
    </DataViewContainer>
  );
};

export default DataView;

const DataViewContainer = styled.div`
  display: grid;
  padding-top: 1em;
`;

const DataSection = styled.div`
  display: grid;
  padding: 1.5em;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 5em auto;
  grid-row-gap: 2em;
`;

const SectionHeader = styled.div`
  display: grid;
  margin: 0 1em;
  grid-template-columns: 6fr 3fr 3fr 1fr;
  grid-column-gap: 2em;
  grid-column-start: 1;
  grid-column-end: 3;
  align-items: center;
  ${TitleText} {
    display: grid;
    grid-template-rows: 2fr fr;
    margin: 0;
    padding: 0;
    color: #214160;
    font-size: 22px;
  }
`;

const MeasuresContainer = styled.div`
  display: grid;
  /* grid-template-rows: 2em auto; */
  grid-column: 1 / span 2;

  ${TitleText} {
    font-size: 14px;
    font-weight: 600;
    line-height: 12px;
    padding: 2em;
  }
  span {
    display: flex;
    flex-direction: row;
    align-items: center;
    ${TitleText} {
      padding-left: 1em;
    }
  }
`;

const Data = styled.div`
  grid-column: 1 / span 2;
`;

const DateRangeContainer = styled.div`
  grid-column: 2 / span 2;
`;
